import type { UiState, UiAction } from './reducers';
import { PublicPortfolioFetch } from '@/components/DeprecatedPortfolios/redux/routines';

function publicPortfolioFetchReducer(
  state: UiState,
  action: UiAction
): UiState {
  const { type } = action;
  switch (type) {
    case PublicPortfolioFetch.REQUEST:
      return {
        ...state,
        fetchPublicPortfolioState: 'fetching',
      };
    case PublicPortfolioFetch.FAILURE:
      return {
        ...state,
        fetchPublicPortfolioState: 'error',
      };
    case PublicPortfolioFetch.FULFILL:
      return {
        ...state,
        fetchPublicPortfolioState: 'idle',
      };
    default:
      return state;
  }
}

export default publicPortfolioFetchReducer;
